import { createFileRoute } from '@tanstack/react-router';
import { SeoMeasurePage } from '@/pages/SeoMeasurePage';

export const Route = createFileRoute('/_authed/seo/measure')({
  component: SeoMeasurePage,
});
